module.exports = __webpack_public_path__ + "img/20_50.41b20724.png";